var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-right-panel" }, [
    _c(
      "div",
      { staticClass: "content" },
      _vm._l(_vm.yyList, function (item, index) {
        return _c("div", { key: index, staticClass: "list-item" }, [
          _c("div", { staticClass: "img-box" }, [
            _c("img", { attrs: { src: item.icon, alt: "" } }),
          ]),
          _c("div", { staticClass: "name" }, [
            _c("i", { staticClass: "point" }),
            _vm._v(_vm._s(item.name)),
          ]),
          _c("div", { staticClass: "total-box" }, [
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
            _vm._v("（ "),
            _c("span", { staticClass: "unit" }, [_vm._v(_vm._s(item.unit))]),
            _vm._v("） "),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }